import user from './module/user.js'
import exam from './module/exam.js'
import questionEdit from './module/questionEdit.js'
import questionExercise from './module/questionExercise.js'
import utils from './module/utils.js'


export default {
    user,exam,questionEdit,questionExercise,utils
}